const University = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M6.5 8L12 10L17.5 8M6.5 8L5.28482 13.6709C5.11291 14.4731 5.45106 15.2975 6.19271 15.6483C7.42763 16.2324 9.52191 17 12 17C14.4781 17 16.5724 16.2324 17.8073 15.6483C18.5489 15.2975 18.8871 14.4731 18.7152 13.6709L17.5 8M6.5 8L4 7.09091M17.5 8L23 6L12 2L1 6L4 7.09091M3 18L2 22H4L3 18ZM3 18V6.72727M12 4.5L4 7.09091"
      stroke="#374151"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default University;
